import * as _ from "lodash";

/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @category Math
 * @param array The array to iterate over.
 * @param iteratee The iteratee invoked per element.
 * @returns Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.a; });
 * // => { 'n': 1 }
 *
 * // using the `_.property` iteratee shorthand
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy<T>(collection: _.List<T> | null | undefined, iteratee?: _.ValueIteratee<T>): T | undefined {
    return _.minBy(collection, iteratee)
};

export const MathUtil = {
   minBy
}

export default MathUtil;